import React, { useState, useEffect } from 'react'
import { timeConstants } from '@sketch/utils'
import { timeUnits } from '../TimeAgo/'
import { dateParser } from '../TimeAgo/DefaultTimeAgo'

// default deletion time in days
const DEFAULT_DELETION_DAYS = 90

interface DeletingInProps {
  deletedAt: Date | string | number
}

export const DeletingIn = ({ deletedAt }: DeletingInProps) => {
  const [timeNow, setTimeNow] = useState(Date.now())

  useEffect(() => {
    const tick = () => {
      const deletionDate = dateParser(deletedAt).valueOf()
      if (!deletionDate) {
        // eslint-disable-next-line no-console
        console.warn('[react-timeago] Invalid Date provided')
        return 0
      }
      const seconds = Math.round(Math.abs(timeNow - deletionDate) / 1000)

      const unboundPeriod =
        seconds < timeConstants.MINUTE
          ? 1000
          : seconds < timeConstants.HOUR
            ? 1000 * timeConstants.MINUTE
            : seconds < timeConstants.DAY
              ? 1000 * timeConstants.HOUR
              : 1000 * timeConstants.WEEK

      const period = Math.min(
        Math.max(unboundPeriod, 1000),
        timeConstants.WEEK * 1000
      )

      if (period) {
        return setTimeout(() => {
          setTimeNow(Date.now())
        }, period)
      }

      return 0
    }
    const timeoutId = tick()
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [deletedAt, timeNow])

  const deletionDate: Date = new Date(deletedAt)
  deletionDate.setDate(deletionDate.getDate() + DEFAULT_DELETION_DAYS)

  const timeToDelete = deletionDate.getTime() - timeNow

  const days = Math.floor(timeToDelete / (24 * 60 * 60 * 1000))

  const string = '(Deleting permanently soon)'

  if (days > 0) {
    return <>{`(Deleting permanently in ${days}${timeUnits['day']})`}</>
  }

  const hours = Math.floor(timeToDelete / (60 * 60 * 1000))
  if (hours > 0) {
    return <>{`(Deleting permanently in ${hours}${timeUnits['hour']})`}</>
  }

  const minutes = Math.floor(timeToDelete / (60 * 1000))
  if (minutes > 0) {
    return <>{`(Deleting permanently in ${minutes}${timeUnits['minute']})`}</>
  }

  return <>{string}</>
}
